import { useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import { useGooglePlacesAutocomplete } from './hooks/useGooglePlacesAutoComplete';
import { useMapStore } from './store';


interface SearchInputProps {
  value?: string;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps & React.HTMLProps<HTMLInputElement>> = ({
  value,
  className = "",
  type="text",
  ...rest
}) => {
  const { map, setSearchPlace } = useMapStore();
  const searchRef = useRef<HTMLInputElement>(null)
    // Autocomplete hook
    const autocomplete = useGooglePlacesAutocomplete(searchRef)
    const onChange = () => {
      if (map && autocomplete) {
        const place = autocomplete.getPlace()
        if (place && place?.geometry?.viewport) {
          map.fitBounds(place.geometry.viewport)
          setSearchPlace(place.name ?? "")
        }
      }
    }
    useEffect(() => {
      if (autocomplete) {
        autocomplete.addListener('place_changed', onChange)
      }
    }, [onChange, autocomplete])
    
  
  return (
    <div className="relative w-full">
      <div className="absolute left-6 top-1/2 -translate-y-1/2">
        <Search className="text-grey-500" size={20} />
      </div>
      <input
        type="text"
        className={`w-full h-[55px] leading-none pl-16 pr-6 rounded-full border border-gray-800 sm:border-grey-500 placeholder:text-grey-500 ${className}`}
        value={value}
        autoComplete="off"
        aria-label="Search"
        {...rest}
        ref={searchRef}
        onFocus={() => {
          if(searchRef?.current?.value) {
            searchRef.current.value = ""
          }
        }}   
      />
    </div>
  );
};

export default SearchInput
